import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Components
import ToolbarTool from '../../ToolbarTool';
import Icon from '../../../../../components/icons/Icon';

// Utils
import { isSelectingMultipleSelections } from '../../../../../element/table/utils/tableCellSelectionUtils';

// Selectors
import { getCurrentCellSelections } from '../../../../../element/table/tableSelector';
import { getElementId } from '../../../../../../common/elements/utils/elementPropertyUtils';
import TableInstanceApiSingleton from '../../../../../element/table/manager/TableInstanceApiSingleton';

const mapStateToProps = createStructuredSelector({
    currentCellSelections: getCurrentCellSelections,
});

const AddColumnTool = (props) => {
    const { element, currentCellSelections } = props;

    const elementId = getElementId(element);

    const updateAddColumn = () => {
        const tableInstanceApi = TableInstanceApiSingleton?.get(elementId);
        if (!tableInstanceApi?.tableOperationsRef.current) return;

        tableInstanceApi.tableOperationsRef.current.addColsRight();
    };

    return (
        <div className="AddColumnTool">
            <ToolbarTool
                {...props}
                onClick={updateAddColumn}
                isActive={false}
                disabled={isSelectingMultipleSelections(currentCellSelections)}
                tooltipEnabled={true}
                shortcut={['alt', '→']}
            >
                <Icon name="toolbar-add-column" />
            </ToolbarTool>
        </div>
    );
};

AddColumnTool.propTypes = {
    iconName: PropTypes.string,
    element: PropTypes.object,
    currentCellSelections: PropTypes.object,
};

export default connect(mapStateToProps)(AddColumnTool);
